import { SOCIAL_NETWORKS } from '@/configs/urls'

export type ArenaSocialLinkKey =
  | 'instagram'
  | 'twitter'
  | 'telegram'
  | 'youtube'

export const ARENA_SOCIAL_LINKS: {
  key: ArenaSocialLinkKey
  href: string
}[] = (
  [
    { key: 'instagram', href: SOCIAL_NETWORKS.INSTAGRAM },
    { key: 'twitter', href: SOCIAL_NETWORKS.TWITTER },
    { key: 'telegram', href: SOCIAL_NETWORKS.TELEGRAM },
    { key: 'youtube', href: SOCIAL_NETWORKS.YOUTUBE }
  ] as const
).filter(link => Boolean(link.href?.trim()))
